module.exports = __webpack_public_path__ + "img/591-42dfb3.png";